import React from "react";
import JarvisInfoContainer from "containers/JarvisInfo";

const JarvisInfo = () =>{

    return (<JarvisInfoContainer />);
}

export default JarvisInfo;